<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                Uniform Products Mapping
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="8" sm="6" xs="12">
            <v-card-text class="pt-0 pr-1" :class="{
              'd-block py-3': $vuetify.breakpoint.xs,
              'd-flex align-center': $vuetify.breakpoint.smAndUp
            }">
              <v-btn v-if="addNewApparel" small class="ml-auto mb-2" elevation="1" @click="addNewProductDialog = true"
                color="accent">
                <v-icon left>mdi-plus</v-icon>
                Add
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <v-data-table :search="search" item-key="id" :headers="headers" :items="productApparels">
              <template v-slot:item.class="{ item }">
                <span>{{ item.class ? item.class.name : '--' }}</span>
              </template>
              <template v-slot:item.isActive="{ item }">
                <span class="has-text-success" v-if="item.isActive">Active</span>
                <span class="has-text-danger" v-else>In Active</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn v-if="addNewApparel" class="ml-1 mb-1" outlined small dense color="primary" elevation="0"
                  :disabled="item.productCount <= 0" @click="editUniformMapping(item)">
                  Edit
                </v-btn>
                <v-btn class="ml-1 mb-1" outlined v-if="!item.isActive && addNewApparel" small id="apply" color="success"
                  elevation="1" type="submit" @click="activeStatus(item)">
                  <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                  Active
                </v-btn>
                <v-btn class="ml-1 mb-1" outlined v-else-if="addNewApparel" small id="apply" color="error" elevation="1"
                  type="submit" @click="deActiveStatus(item)">
                  <v-icon left size="18"> mdi-delete </v-icon> DeActive
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog persistent v-model="addNewProductDialog" max-width="1000" :active="addNewProductDialog" :on-cancel="() => {
        addNewProductDialog = false
        clearData()
      }
        ">
        <form @submit.prevent="addNewProduct" enctype="multipart/form-data" name="SaveUniformMapping">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title> Add Skills</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="() => {
                  ; (addNewProductDialog = false), clearData()
                }
                  ">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-row>
              <v-col cols="12" md="4" lg="4" sm="4" xs="6">
                <!-- <div class="content">
              <b> .csv file must contain<br /></b>
              <ul>
                <li>
                  FCID: Creator needs to provide FCID and it must be numeric.
                </li>
                <li>
                  Quantity: quantity of FCID needs to be provided and it must be
                  numeric.
                </li>
                <li>
                  Mandatory / Optional: In 3rd column, whether that FCID
                  ismandatory or optional in ordering will be provided.
                </li>
                <li>
                  Alternate FCID 1 (Optional): If not blank must be contain
                  numeric value.
                </li>
                <li>
                  Alternate FCID 2 (Optional): If not blank must be contain
                  numeric value.
                </li>
              </ul>
            </div> -->
              </v-col>
              <v-col cols="12" md="4" lg="4" sm="4" xs="6">
                <b-field>
                  <b-upload v-model="dropFiles" @input="csvToJsonInput(dropFiles)" accept=".csv" single drag-drop
                    title="Please do upload .csv file only">
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
                <div v-show="flag">
                  <v-chip class="mt-1" color="indigo" text-color="white" @click:close="deleteDropFile" close label>
                    {{
                      dropFiles !== null && dropFiles.name !== 'undefined'
                      ? dropFiles.name
                      : ''
                    }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12" md="4" lg="4" sm="4" xs="6">
                <div class="column has-text-centered">
                  <a class="button is-link" href="https://intellitots.s3.ap-south-1.amazonaws.com/KitConfiguration.csv"
                    download>Download dummy file</a>
                </div>
              </v-col>
              <v-col cols="12" md="12" xs="12" lg="12" sm="12">
                <footer class="column has-text-centered">
                  <button class="button is-success" type="submit">Upload</button>
                </footer>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                <div class="columns is-mobile">
                  <div class="column" v-if="resCountFlag" style="display: inline-block; margin-right: 5%">
                    <b-button class="has-text-left" outlined type="is-success">Success: {{ resCount.success }}
                    </b-button>&nbsp;
                    <b-button class="button has-text-centered" outlined type="is-info">Already Exist: {{
                      resCount.alreadyExist }}</b-button>&nbsp;
                    <b-button class="button has-text-right" outlined type="is-danger">Failure: {{ resCount.failure
                    }}</b-button>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" lg="12" xs="12" sm="12">
                <v-data-table v-if="jsonData.length > 0" disable-pagination :hide-default-footer="true"
                  :headers="jsonHeader" :items="jsonData">
                  <template v-slot:item.status="{ item }">
                    <span :class="item.statusCode === 200
                      ? 'has-text-success'
                      : 'has-text-danger'
                      ">{{ item.status }}
                    </span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </form>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
// import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
import csvtojsonV2 from 'csvtojson'

export default {
  name: 'uniformmapping',
  // components: {
  //   CardComponent
  // },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      columns: [],
      responseData: [],
      isModalActive: false,
      clients: [],
      paginated: false,
      perPage: 10,
      checkedRows: [],
      status: true,
      total: 0,
      loadingComponent: null,
      search: '',
      headers: [
        { text: 'Sr.No', sortable: true, value: 'index', align: 'center' },
        { text: 'Product Apparel Type', value: 'productApparelType', sortable: true, align: 'center' },
        { text: 'Sub Type', value: 'subType', sortable: true, align: 'center' },
        { text: 'Gender', value: 'gender', sortable: true, align: 'center' },
        { text: 'Class', value: 'class', sortable: true, align: 'center' },
        { text: 'Product ID', value: 'productID', sortable: true, align: 'center' },
        { text: 'Alt. Product ID', value: 'alternateFCID', sortable: true, align: 'center' },
        { text: 'Size', value: 'size', sortable: true, align: 'center' },
        { text: 'Quantity', value: 'quantity', align: 'center' },
        { text: 'Is Active', value: 'isActive', align: 'center' },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      productApparels: [],
      addNewApparel: false,
      addNewProductDialog: false,
      dropFiles: [],
      flag: '',
      jsonData: [],
      jsonHeader: [
        { text: 'Product ID', value: 'productID' },
        { text: 'Alt. Product ID', value: 'alternateFCID' },
        { text: 'Size', value: 'size' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Status', value: 'status' }
      ],
      isResponse: false,
      resCountFlag: false,
      resCount: null,
      csvErrorFlag: false
    }
  },
  created () {
    this.mappingData()
    this.addNewApparel = this.checkModuleAccess('addNewApparel')
  },
  methods: {
    addNewProduct: async function () {
      if (this.csvErrorFlag) {
        return this.$dialog.error({
          title: 'Error in CSV data',
          text: 'Incorrect CSV data. Please check before upload.'
        })
      }
      this.$dialog.confirm({
        text: 'Do you really want to save?',
        title: 'Confirm',
        actions: {
          false: {
            text: 'Cancel',
            handle: () => {
              this.dropFiles = []
            }
          },
          true: {
            color: 'success',
            text: 'Ok',
            handle: async () => {
              this.loadingComponent = this.$buefy.loading.open()
              /* Add Record */
              try {
                let payload = {}
                payload.productList = this.jsonData
                await http
                  .post(
                    `${constants.API_URL}/api/uniform/bulk-create-uniform-product`,
                    payload
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      if (res.data.response.length > 0) {
                        this.jsonData = res.data.response
                        if (Object.keys(res.data.count).length > 0) {
                          this.resCountFlag = true
                          this.resCount = res.data.count
                        }
                      }
                    }
                  })
                this.loadingComponent.close()
                this.loader = false
              } catch (e) {
                this.loadingComponent.close()
                const errorTitle =
                  (e && e.response && e.response.data.error) || e.error
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  title: errorTitle,
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    },
    editUniformMapping: async function (item) {
      this.$router.push({
        name: 'editUnifromProductApparel',
        params: { productApparelID: item.productApparelID }
      })
      return true
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    deleteDropFile (index) {
      this.isResponse = false
      delete this.dropFiles.name
      this.jsonData = []
      this.dropFiles = []
      this.flag = false
      this.resCountFlag = false
      this.resCount = {}
      return this.dropFiles
    },
    readerFile: function (file, onLoadCallback) {
      let reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: function (files) {
      if (files === null) {
        return this.$dialog.error({
          title: 'Error while choosing the file',
          text: 'Incorrect file format. Please upload .csv file'
        })
      } else {
        // let kitName = []
        this.loadingComponent = this.$buefy.loading.open()
        this.isResponse = false
        let self = this
        this.resCountFlag = false
        this.resCount = {}
        this.csvErrorFlag = false

        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files

        this.readerFile(file, async (e) => {
          try {
            let numberPattern = /^\d+\.?\d*$/
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
            /* Resolve Empty Value, Check string contains only numeric value or not and convert it to number */
            _.forEach(self.jsonData, (item) => {
              // check product id
              if (item.productID !== '' && !_.isEmpty(item.productID)) {
                item.productID = Number(
                  numberPattern.test(item.productID) ? item.productID : 0
                )
              } else {
                item.productID = 0
              }
              // check alternate FCID
              if (
                item.alternateFCID !== '' &&
                !_.isEmpty(item.alternateFCID)
              ) {
                item.alternateFCID = Number(
                  numberPattern.test(item.alternateFCID)
                    ? item.alternateFCID
                    : 0
                )
              } else {
                item.alternateFCID = 0
              }
              // check size
              if (item.size !== '' && !_.isEmpty(item.size)) {
                item.size = _.trim(item.size)
              } else {
                item.size = ''
              }
              // check quantity
              if (item.quantity !== '' && !_.isEmpty(item.quantity)) {
                item.quantity = Number(
                  numberPattern.test(item.quantity) ? item.quantity : 0
                )
              } else {
                item.quantity = 0
              }
              // check chest
              if (item.chest !== '' && !_.isEmpty(item.chest)) {
                item.chest = parseFloat(item.chest)
              } else {
                item.chest = 0
              }
              // check front length
              if (item.frontLength !== '' && !_.isEmpty(item.frontLength)) {
                item.frontLength = parseFloat(item.frontLength)
              } else {
                item.frontLength = 0
              }
              // check shoulder size
              if (item.shoulderSize !== '' && !_.isEmpty(item.shoulderSize)) {
                item.shoulderSize = parseFloat(item.shoulderSize)
              } else {
                item.shoulderSize = 0
              }
              // check waist relax
              if (item.waistRelax !== '' && !_.isEmpty(item.waistRelax)) {
                item.waistRelax = parseFloat(item.waistRelax)
              } else {
                item.waistRelax = 0
              }
              // check waist stretch
              if (item.waistStretch !== '' && !_.isEmpty(item.waistStretch)) {
                item.waistStretch = parseFloat(item.waistStretch)
              } else {
                item.waistStretch = 0
              }
              // check length
              if (item.length !== '' && !_.isEmpty(item.length)) {
                item.length = Number(
                  numberPattern.test(item.length) ? item.length : 0
                )
              } else {
                item.length = 0
              }
              // check product Name
              if (item.productName !== '' && !_.isEmpty(item.productName)) {
                item.productName = _.trim(item.productName)
              } else {
                item.productName = ''
              }
              // check type
              if (item.type !== '' && !_.isEmpty(item.type)) {
                item.type = _.trim(item.type)
              } else {
                item.type = ''
              }
              // check sub type
              if (item.subType !== '' && !_.isEmpty(item.subType)) {
                item.subType = _.trim(item.subType)
              } else {
                item.subType = ''
              }
              // check gender
              if (item.gender !== '' && !_.isEmpty(item.gender)) {
                item.gender = _.trim(item.gender)
              } else {
                item.gender = ''
              }

              item.isMandatory =
                item.isMandatory !== '' ? item.isMandatory : 'No'
            })

            /* Add Validation for FCID,Quantity,alternateFCID1,alternateFCID2 */
            _.forEach(self.jsonData, (item) => {
              let errorMsg = ''

              if (typeof item.productID === 'undefined' || item.productID === 0) {
                errorMsg += 'ProductId' + ', '
              }
              if (typeof item.quantity === 'undefined' || item.quantity < 0) {
                errorMsg += 'Quantity' + ', '
              }
              if (item.productID === item.alternateFCID) {
                errorMsg += 'Product and Alt. Product should not be equal' + ', '
              }

              if (!this.csvErrorFlag) {
                this.csvErrorFlag = errorMsg !== ''
              }
              item.status = errorMsg !== '' ? errorMsg.slice(0, -2) : ''
              item.statusCode = errorMsg !== '' ? 99 : 200
            })
          } catch (e) {
            self.jsonData = 'this is not running'
          }
        })
        this.flag = true
        this.loadingComponent.close()
      }
    },
    mappingData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(`${constants.API_URL}/api/uniform/get-all-products`)
        this.productApparels = response.data
        _.map(this.productApparels, (obj, key) => {
          obj.index = key + 1
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    activeStatus: async function (selectedId) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to active ?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            let response = await http.get(`${constants.API_URL}/api/uniform/active-product-apparel/${selectedId.productApparelID}`)
            that.mappingData()
            if (response.status === 200) {
              return that.okMsg('Product Apparel status updated.')
            }
          } catch (e) {
            const errorTitle = (e && e.response && e.response.data.error) || e.error
            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            return this.$dialog.error({
              title: errorTitle,
              text: errorMessage
            })
          }
        }
      })
    },
    deActiveStatus: async function (selectedId) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to remove ?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            let response = await http.get(`${constants.API_URL}/api/uniform/deActive-product-apparel/${selectedId.productApparelID}`)
            that.mappingData()
            if (response.status === 200) {
              return that.okMsg('Product Apparel status updated.')
            }
          } catch (e) {
            const errorTitle = (e && e.response && e.response.data.error) || e.error
            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            return this.$dialog.error({
              title: errorTitle,
              text: errorMessage
            })
          }
        }
      })
    },
    clearData () {
      this.dropFiles = []
      this.productApparels = null
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
